import Session from 'components/utils/session';

export default {
  isLoading: false,
  isVerified: false,
  isAuthenticated: !!Session.token,
};
